export default {
  UPSERT_USER_GROUP: "UPSERT_USER_GROUP",
  GET_USER_GROUPS: "GET_USER_GROUPS",
  DELETE_USER_GROUP: "DELETE_USER_GROUP",
  UPSERT_DOCUMENT_TYPE: "UPSERT_DOCUMENT_TYPE",
  DELETE_DOCUMENT_TYPE: "DELETE_DOCUMENT_TYPE",
  GET_DOCUMENT_TYPES: "GET_DOCUMENT_TYPES",
  UPSERT_USER: "UPSERT_USER",
  GET_USER: "GET_USER",
  DELETE_USER: "DELETE_USER",
  UPSERT_METADATA_KEYS: "UPSERT_METADATA_KEYS",
  DELETE_METADATA_KEYS: "DELETE_METADATA_KEYS",
  GET_METADATA_KEYS: "GET_METADATA_KEYS",
  UPSERT_FOLDER: "UPSERT_FOLDER",
  GET_FOLDERS: "GET_FOLDERS",
  DELETE_FOLDER: "DELETE_FOLDER",
  UPSERT_COMPARTMENT: "UPSERT_COMPARTMENT",
  DELETE_COMPARTMENT: "DELETE_COMPARTMENT",
  GET_COMPARTNENTS: "GET_COMPARTNENTS"
};
